import renderIcon from 'helpers/renderIcon';
import { INodeDto } from 'models/common';
import { ICustomer } from 'models/shop/customer';
import { IUserCard } from 'models/user/usercard';
import { IUserDropdownItem, IUserDropdownValue } from 'models/user/userlistitem';
import { IUserPreferences } from 'models/user/userpreferences';
import * as React from 'react';
import { AvatarSmall } from '../AvatarSmall';
import { IOfficeMember } from 'models/shop/members';

interface IProps {
	onClick?: () => void;
	vertical?: boolean;
	description?: string;
	className?: string;
	hasArrow?: boolean;
	customIcon?: JSX.Element;
	shortenName?: boolean;
	limitTextLength?: boolean;
}

interface IStaticProps {
	imageUrl?: string;
	name: string;
	phoneNumber?: string;
}

interface IUserProps {
	user: IUserPreferences | IUserDropdownItem | IUserDropdownValue | ICustomer | IUserCard | INodeDto | IOfficeMember;
}

type Props = IProps & (IStaticProps | IUserProps);

interface INormalizedUser {
	imageUrl?: string;
	name: string;
	description?: string;
}

const normalizeUser = (user: IUserProps['user'], shortenName: boolean, limitTextLength: boolean): INormalizedUser => {
	let name: string = '';
	let imageUrl: string;
	let description: string;

	if ('profilePicture' in user) {
		imageUrl = user.profilePicture;
		name = user.name || user.givenName;
		description = user.email; // TODO: maybe not?
	} else if ('picture' in user) {
		imageUrl = user.picture;
		name = user.name;
	} else if ('image' in user) {
		imageUrl = user.image;
		name = user.value.name;
		description = user.description;
	} else if ('name' in user) {
		name = user.name;
	}

	if ('jobTitle' in user) {
		description = user.jobTitle;
	}

	if (!limitTextLength && shortenName && name) {
		const nameSplit = name.split(' ');
		name = nameSplit[0] + ' ' + nameSplit[nameSplit.length - 1].charAt(0) + '.';
	}

	if (limitTextLength && !shortenName && name?.length > 22) {
		const nameShortened = name.substring(0, 22) + '...';
		name = nameShortened;
	}

	if (limitTextLength && description && description?.length > 25) {
		const descriptionShortened = description.substring(0, 25) + '...';
		description = descriptionShortened;
	}

	return {
		imageUrl,
		name,
		description,
	};
};

const PersonItem: React.FC<Props> = (props: Props) => {
	const { className, vertical, onClick, hasArrow, customIcon } = props;
	const shortenName = props?.shortenName || false;
	const limitTextLength = props?.limitTextLength || false;
	let normalized: INormalizedUser;
	if ('user' in props) {
		normalized = normalizeUser(props.user, shortenName, limitTextLength);
	} else {
		normalized = props;
	}
	return (
		<div
			onClick={onClick ? onClick : undefined}
			className={'personItem ' + (vertical ? 'vertical ' : '') + (className ? className : '')}
		>
			<AvatarSmall onClick={onClick} customIcon={customIcon} imageUrl={normalized.imageUrl} name={normalized.name} />
			<div>
				<strong>{normalized.name}</strong>
				{normalized.description ? <small>{normalized.description}</small> : null}
			</div>
			{hasArrow ? <div className="arrowIcon">{renderIcon('search_go')}</div> : null}
		</div>
	);
};

export { PersonItem };
